module.exports = __webpack_public_path__ + "static/media/controller-gray.692b80f9.svg";